export enum UmpireOttPlaylistResourceKind {
  EVENTS = 'events',
  TAGS = 'tags',
}
